import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    table: {
      overflow: 'auto !important',
      '&::-webkit-scrollbar': {
        height: 12,
        width: 8.5,
      },
      '&::-webkit-scrollbar-thumb': {
        background: 'rgba(170, 184, 194, 0.8);',
        borderRadius: 15,
      },
      scrollbarWidth: 'thin',
      msOverflowStyle: 'auto',
      marginTop: 68,
      '& table': {
        borderRadius: 15,
        overflow: 'hidden',
        marginBottom: 30,
      },
      '& thead': {
        background: '#14171A',
        borderRadius: '15px 15px 0px 0px',
      },
      '& thead th': {
        color: '#fff',
        borderBottom: 'none',
      },
      '& thead tr > *': {
        padding: theme.spacing(0.5, 5),
      },
      '& tbody tr > *': {
        padding: theme.spacing(0.5, 5),
      },
      '& tbody tr:nth-of-type(odd) ': {
        background: '#fff',
      },
      '& tbody tr:nth-of-type(even)': {
        background: '#F5F8FA',
      },
      '& td': {
        borderBottom: 'none',
      },
    },
  }),
);

export default useStyles;
